export default function () {
	return {
		begin_date: null,
    	end_date: null
	}
}
